import axios from 'axios';

const instance = axios.create({
  baseURL: window.location.origin,
  timeout: 20000,
  headers: {
    Accept: 'application/json', 'Content-Type': 'application/json'
  },
  responseType: "json"
});


export default {
  setAuthToken(token){
    instance.defaults.headers.common['Authorization'] = "Bearer " + token;
  },

  request(options) {
    return instance.request(options);
  }
}
